import Add2cartView from '../views/add2cart.view.html';
import { CartItem } from '../common/common';


class Add2cartController {
    constructor(sharedData) {
        'ngInject';

        this.sharedData = sharedData;
        this.cartItem = null;
    }

    $onChanges() {
        const element = {
            id: this.id,
            name: this.name,
            quantity: this.quantity,
            options: this.options,
            associate: this.associate
        };
        this.cartItem = new CartItem(element);
    }

    add() {
        this.sharedData.cart.add(this.cartItem);
    }

    checkIfInCart() {
        const check = this.sharedData.cart.checkIfInCart(this.cartItem);
        if (check) {
            this.cartItem = check;
        }

        return check;
    }

    remove() {
       this.sharedData.cart.remove(this.cartItem);
    }
}

let add2cartComponent = {
    bindings: {
        id: '<',
        name: '<',
        quantity: '<',
        options: '<',
        associate: '<'
    },
    template: Add2cartView,
    controller: Add2cartController
};

export default add2cartComponent;